export const contactsData = {
    email: 'akrajput01206@gmail.com',
    phone: '+91 8802683717',
    address: 'North east Delhi. Delhi-110053, India',

    sheetAPI: 'https://sheetdb.io/api/v1/oi8t4iriby7x8'
}